import { useSupportTickets } from '@/hooks/useSupportTickets';

/**
 * Open-ticket count for the global HQ Queue badge (TopBar + ModuleTopBar).
 * Reuses the exact list query behind useTicketCounts' `counts.open` — the
 * "N need a reply" badge on the HQ Queue page itself — status 'open', page 1,
 * limit 1, unfiltered, so the two share a single React Query cache entry
 * and 30s refetch interval instead of issuing a second request. No new
 * endpoint, no duplicated counting logic.
 */
export function useHqQueueCount(enabled = true): number {
  const { data } = useSupportTickets(
    { status: 'open', page: 1, limit: 1 },
    { enabled },
  );
  return data?.total ?? 0;
}
